import React, {Component} from 'react';
import downredthin from 'assets/icons/down-red.svg';
import upgreenthin from 'assets/icons/up-green.svg';
import './Note.style.scss';
export default class Note extends Component {
  render() {
    return (
      <div className='note-container'>
        <ul className='note-list'>
          <li className='note-list-item'>
            (*) With LOBs reporting dimension, this indicator may not be available{' '}
          </li>
          <li className='note-list-item'>
            (**) With LOBs reporting dimension, evaluation objects can be sub segments
          </li>
          <li className='note-list-item'>(***) Does not apply to LOBs</li>
        </ul>
        <p className='note-des'>
          <span className='note-inc'>
            <img src={upgreenthin} alt='' width={16} height={16} />
            Increase
          </span>
          <span className='note-dec'>
            <img src={downredthin} alt='' width={16} height={16} />
            Decrease
          </span>
          <span>compare with previous period</span>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/Note/Note.js